import {useState} from "react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import {GeoLocationIcon, PositionIcon} from "../components/icons";
import baseApi from "../baseApi";

export default function SearchInput({ showMap, geoChange, departmentChange }) {
  const [currentLocalisation,setCurrentLocalisation] = useState(null)
  const {t} = useTranslation()
  const [geoActive, geoActiveSet] = useState('INIT');
  const [zipCode, zipCodeSet] = useState('');
  const [zipCodeError, zipCodeErrorSet] = useState(false);
  const [suggest, suggestSet] = useState([]);



  const pSearch = (zip, city) => {
    const sQ = {postalcode: zip, format: 'jsonv2', country: 'France'};
    if (city) sQ.city = city;
    const [query] = baseApi.GET({
      path: "/search",
      origin: "https://nominatim.openstreetmap.org",
      query: sQ,
      headers: {'content-type': 'application/json', 'access-control-allow-methods': 'OPTIONS,GET',  'access-control-allow-origin': '*'}
    })

    return query;
  }


  const searchLoc = (zip, city) => {
    const query = pSearch(zip);



    query
    .then(results => {
      if (results.length < 1 && city) {
        return pSearch(zip, city)
          .then(innerResults => {
            if (!innerResults.length) return false;

            return innerResults[0];
          });
      }

      return results[0];
    })
    .then(coord => {
      if (!coord) {
        zipCodeErrorSet(true)
        console.error("Error on finding location by zipCode:", zip);
        return;
      }
      
      geoChange({lat: +(coord.lat), lng: +(coord.lon)});
      
    })
    .catch( e => {
      console.error("Cannot search by zip", e)
      zipCodeErrorSet(true);
    })

    return query;
  };

  const onFormSubmit = (e) => {
    e && e.preventDefault();

    if (zipCode === ''){
      departmentChange(null);
      return;
    }
    zipCodeErrorSet(false);
    if( zipCode.length <= 4 ) {
      departmentChange(zipCode);
      // return;
    }

    pCitySearch(zipCode).then(json => {
      const s = json[0];
      if (!s) return {ville_code_postal : zipCode, ville_nom_reel : false};

      return s;
    })
    .then(s => s && searchLoc(s.ville_code_postal, s.ville_nom_reel))
    .then(found => !!found && suggestSet(false))
    .catch( e => {
      console.error("Cannot search by zip", e)
      zipCodeErrorSet(true);
    })
  };


  const pNavigatorGeoLocSearch = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition((pos) => {
        resolve({lat: pos.coords.latitude, lng: pos.coords.longitude});
      }, reject, {timeout : 5000, enableHighAccuracy: false});
    })
  }

  const searchByGeoloc = () => {

    if (geoActive === 'LOAD') return;

    if (! ("geolocation" in navigator) ) {
      console.error("Geolocation is not available");
      return;
    }

    geoActiveSet('LOAD');

    pNavigatorGeoLocSearch()
      .then(res => {
        zipCodeSet('');
        zipCodeErrorSet(false)
        geoChange(res);
        geoActiveSet('DONE');
      })
      .catch(err => {
        console.error(err);
        geoActiveSet('ERROR');
      })

  };

  const pCitySearch = (value) => {
    const [query] = baseApi.GET({
      path: `/api/abo/city`,
      query: { query : value }
    })
    query
    .then( json => {
      return json;
    })
    .catch( e => {
      console.error('ee', e)
    });

    return query;
  }

  const onChange = e => {
    const v = e.target.value;
    zipCodeSet(v);
    return pCitySearch(v).then(json => suggestSet(json));
  };

  const geoActiveStatusText = {
    'DONE' : t('club_selection.search.gps.we_found_you'),
    'INIT' : t('club_selection.search.gps.find_me'),
    'LOAD' : t('club_selection.search.gps.waiting'),
    'ERROR' : t('club_selection.search.gps.error'),
  }[geoActive];

  return (
    <div className={`w-full flex gap-2 py-4 px-5 justify-between items-center my-6 bg-white md:py-4 lg:py-6 md:px-5 lg:px-8 lg:gap-10 md:round-[8px] md:shadow-sm md:shadow-black ${showMap?'':'shadow-md shadow-black p-1 rounded-[8px]'}`}>
      <div className="text-xs lg:text-2xl text-nowrap font-bold text-oaRed" >
        <p className="text-center">{t("club_selection.search.gps.i_found_my_club").toUpperCase()}</p>
        <button className="flex gap-1 justify-start items-center" onClick={searchByGeoloc}>
          {geoActive ? <PositionIcon className={`hidden md:block md:size-3 lg:size-6 animate-bounce `}/> :<GeoLocationIcon className={`hidden md:block md:size-4 lg:size-7 `}/>}
          <p className="lg:text-xl underline text-oaForegroundText uppercase">{geoActiveStatusText}</p>
        </button>
      </div>
      <form className="relative w-full" onSubmit={onFormSubmit}>
        <div className="flex flex-1 items-center gap-1 relative h-9 md:h-12 lg:h-14 xl:h-20">
          <input
            className={`h-full w-full rounded-[6px] border border-oaGray md:bg-oaLightGray focus:border-oaRed outline-none placeholder:text-[10px] lg:placeholder:text-2xl md:placeholder:text-lg text-xs md:text-2xl bg-background px-2 md:shadow-md md:shadow-oaLightGray  disabled:cursor-not-allowed disabled:opacity-50`}
            value={zipCode}
            onChange={onChange}
            placeholder={t("club_selection.search.place_holder")}
          />
          <Search className="size-5 text-oaPlaceholderText lg:absolute lg:right-2 md:size-6 xl:size-9 " />
        </div>
        <ul className="absolute bg-[#131614] text-white rounded-[8px] max-h-80 overflow-y-auto custom-scrollbar w-full z-[10000000000000000] mt-1 animate-fade-in-down">
           {suggest && !!suggest.length && suggest.map((s, index) => (
             <li
               key={index}
               className="p-2 hover:bg-gray-900 cursor-pointer"
               onClick={(e) =>{
                  zipCodeSet(s.ville_nom_reel);
                  searchLoc(s.ville_code_postal, s.ville_nom_reel);
                  suggestSet(false);
                }}
             >
               <div>{s.ville_nom_reel}</div>
               <div className="text-sm text-gray-500">
                 {s.ville_code_postal}
               </div>
             </li>
           ))}
         </ul>
      </form>
    </div>
  );
}

